import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { DiagramToothAndBridgeListViewItem, IntuitiveIndication } from '../../models';
import { TREATMENT_PREVIEW_LINE_EMPTY } from '../../utils/build-treatment-preview-line';
import { isImplantIndication } from '@shared/utils/procedure-type-util';
import { RxIntuitiveIndicationRulesService } from '@modules/rx-intuitive-teeth-diagram/services/rx-intuitive-indication-rules.service';
import { RxIntuitiveTreatmentViewlistItemBaseComponent } from '../rx-intuitive-treatment-viewlist-item-base/rx-intuitive-treatment-viewlist-item-base.component';

@Component({
	selector: 'rx-intuitive-tooth-treatment-viewlist-item',
	templateUrl: './rx-intuitive-tooth-treatment-viewlist-item.component.html',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, TranslateModule, RxIntuitiveTreatmentViewlistItemBaseComponent]
})
export class RxIntuitiveToothTreatmentViewlistItemComponent {
	@Input() item!: DiagramToothAndBridgeListViewItem;

	get indicationId(): IntuitiveIndication {
		return this.item.indicationId;
	}

	get isIndicationVisible(): boolean {
		return this.indicationId !== this.indicationsService.getDefaultIndication();
	}

	get toothNumberLabel(): string {
		return String(this.item.startToothNumberInSystem);
	}

	get previewLine(): string {
		return this.item.previewLine;
	}

	get previewTitle(): string {
		return this.item.previewTitle;
	}

	get hasCrownTreatmentPreview(): boolean {
		return this.previewLine !== TREATMENT_PREVIEW_LINE_EMPTY;
	}

	get isImplantIndication(): boolean {
		return isImplantIndication(this.indicationId);
	}

	get implantsSummaryLine(): string | null {
		return this.item.implantsSummaryLine ?? null;
	}

	constructor(private readonly indicationsService: RxIntuitiveIndicationRulesService) {}
}
